import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import {RouterView} from 'mobx-state-router';
import {ToastContainer} from 'react-toastify';
import {Loader, GlobalDragDropListener} from 'core/components';
import FormDebugPanel from 'core/components/FormDebugPanel';
import { useStores } from 'core/stores/StoreContext';

import '@progress/kendo-theme-default/dist/all.scss';

const App = observer(() => {
    const { appStore, routerStore, routerMaps } = useStores();

    useEffect(() => {
        appStore.initialize();
    }, [appStore]);

    if (!appStore.initialized) return <Loader/>;

    return (
        <React.Fragment>
            <GlobalDragDropListener/>
            <RouterView routerStore={routerStore} viewMap={routerMaps}/>
            <ToastContainer
                position='bottom-center'
                autoClose={5000}
                hideProgressBar={true}
                newestOnTop={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            {process.env.NODE_ENV !== 'production' && <FormDebugPanel/>}
        </React.Fragment>
    );
});

export default App;
